<template>
  <Carousel
    :items-to-show="3"
    :autoplay="5000"
    :pause-autoplay-on-hover="true"
    :mouse-drag="false"
    :touch-drag="false"
    :transition="500"
    :gap="0"
    loop="true"
    snap-align="start"
    :wrap-around="true"
    class="galeria"
  >
    <Slide v-for="image in imagens" :key="image">
      <section>
        <img
          :src="image"
          alt="Tela"
          class="galeria-img"
        />
      </section>
    </Slide>
  </Carousel>
</template>

<script setup>
import { Carousel, Slide, Pagination, Navigation } from "vue3-carousel"

defineProps({
  imagens: {
    type: Array,
    required: true
  }
})
</script>

<style>
.galeria {
  width: 100%;
  max-width: 520px;
  margin: auto;
  padding: 4px;
  display: flex;
  gap: 4px;
  overflow-x: auto;
  overflow-y: hidden;
  scroll-behavior: smooth;
}

.galeria::-webkit-scrollbar {
  display: none;
}

.galeria img {
  flex: 0 0 auto;
  width: 100%;
  height: 200px;
  object-fit: cover;
  border-radius: 12px;
  border: 2px solid var(--borda-card);
  background-color: var(--fundo-card);
}
</style>